import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const accountApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAccountList: builder.query<any, any>({
            query: (args) => "/account".concat(generateFormatedURL(args)),
        }),
        createAccount: builder.mutation({
            query: (formData) => {
                return {
                    url: "/account",
                    headers:{ 'Content-Type': 'application/json'},
                    method: "POST",
                    body: formData,
                }
            }
        }),
        updateAccount: builder.mutation({
            query: (formData) => {
                return {
                    url: "/Account",
                    method: "PUT",
                    body: formData,
                }
            }
        }),
    })
})

export const {
    useLazyGetAccountListQuery,
    useCreateAccountMutation,
    useUpdateAccountMutation,
} = accountApiSlice;